<template>
  <div class="h-100">
    <v-card elevation="0" outlined class="h-100" v-if="team && !loading" width="100%" min-height="350">
      <v-card-title>
        <v-icon color="secondary" large class="mr-2">shield</v-icon>
        <div class="d-flex flex-column">
          <span
            class="primary--text monospace-font body-1 font-weight-medium"
          >{{$t("dashboards.myTeam")}}</span>
          <!-- <span
            class="subheader-font body-2"
          > </span> -->
        </div>
      </v-card-title>
      <v-row no-gutters class="pb-4 px-4 pt-2">
        <v-col cols="auto">
          <router-link  :to="`/team/${team.teamId}`">
            <img
              v-bind:class="{'grey lighten-3 rounded-lg border': !$vuetify.theme.dark,'black lighten-3 rounded-lg border': $vuetify.theme.dark}"
              class="pa-1"
              :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + team.teamId + '.png'"
              :height="$vuetify.breakpoint.smAndDown ? '60' : '90'"
              contain
              @error="onImageLoadFailure($event,'team')"
            />
          </router-link>
        </v-col>
        <v-col class="pl-4 pr-2">
          <div class="d-flex flex-column h-100">
            <router-link
              class="text-h6 font-weight-medium"
              :to="`/team/${team.teamId}`"
            >{{team.teamName}}</router-link>
            <span class="subheader-font mt-n1">{{team.coachName}}</span>
            <span class="flex-grow-1 d-flex align-center body-2 primary--text text--lighten-2">
              <b class="mr-2 primary--text" v-if="team.ranking">#{{ team.ranking }}</b>
              <span class="mr-2" v-if="team.ranking">at</span>
              <DriblabCountryFlag className="mr-1" :iso="team.countryCode" ></DriblabCountryFlag>
              <span>{{ team.leagueName }}</span>
              <span>{{ team.year }}</span>
            </span>
          </div>
        </v-col>
        <v-col cols="auto" class="align-self-stretch">
          <div class="d-flex justify-center align-center pa-2 h-100"
              v-bind:class="{'grey lighten-3 rounded-lg border': !$vuetify.theme.dark,'black lighten-3 rounded-lg border': $vuetify.theme.dark}">
            <span class="primary--text font-weight-bold text-sm-h5 body-2">{{currentUserCurrencySymbol}}</span>
            <h2
              class="px-1 primary--text font-weight-bold monospace-font"
            >{{ team.marketValue | formatCash(currentUserRate) }}</h2>
          </div>
        </v-col>
      </v-row>
      <v-divider v-if="team.averageAge || team.transferBalance"></v-divider>
      <v-row v-if="team.averageAge || team.transferBalance">
        <v-col cols="12" class="pl-7 d-flex align-center flex-wrap pr-5 pt-1 pb-0">
          <div class="d-flex flex-column mr-5" v-if="team.averageAge">
            <span class="body-2 primary--text subheader-font">{{$t("team.averageAge")}}</span>
            <span
              class="body-1 font-weight-medium primary--text text-ellipsis"
              style="max-width:185px"
              :title="team.averageAge"
            >
              {{parseInt(team.averageAge)}}
              <span class="ml-1">{{$t('playerDetail.yearsOld')}}</span>
            </span>
          </div>
          <div class="d-flex flex-column mr-5" v-if="team.transferBalance">
            <span class="body-2 primary--text subheader-font">{{$t("team.transferBalance")}}</span>
            <span
              class="body-1 font-weight-medium primary--text text-ellipsis"
              style="max-width:185px"
              :title="team.transferBalance"
            >{{team.transferBalance | formatCash(currentUserRate)}}</span>
          </div>
          <div class="d-flex flex-column mr-5" v-if="team.parentId">
            <span class="body-2 primary--text subheader-font">{{$t("team.parentTeam")}}</span>
            <router-link :to="`/team/${team.parentId}`"
              class="body-1 font-weight-medium primary--text text-ellipsis"
              style="max-width:185px"
            >{{team.parentName}}</router-link>
          </div>
          <!--
          <div class="d-flex flex-column mr-5" v-if="team.childId">
            <span class="body-2 primary--text">{{$t("team.childTeam")}}</span>
            <router-link :to="`/team/${team.childId}`"
              class="body-2 font-weight-medium text-ellipsis"
              style="max-width:185px"
            >{{team.childName}}</router-link>
          </div>
          -->
        </v-col>
      </v-row>
      <v-divider class="my-1" style=""></v-divider>
      <div class="d-flex justify-end px-2 py-2">
        <v-btn color="secondary" class="elevation-0 monospace-font white--text px-5" rounded small :to="`/team/${teamId}`">{{$t('dashboards.seeMyTeam')}}</v-btn>
      </div>
    </v-card>
    <v-card class="d-flex justify-center align-center py-8 px-12" v-if="loading" elevation="0" outlined>
      <v-progress-circular :size="75" color="secondary" indeterminate></v-progress-circular>
    </v-card>
  </div>
</template>

<script>
import TeamService from "../../../services/team/team.service";
import { formatCash,getCurrencies } from "../../../utils/functions";
import DriblabCountryFlag from '../../base/DriblabCountryFlag';

export default {
  name: "TeamWidget",
  props: {
    teamId: {
      type: Number,
      required: true
    }
  },
  components:{
    DriblabCountryFlag
  },
  data() {
    return {
      team: null,
      loading: false
    };
  },
  filters: {
    formatCash(n,rate) {
      return formatCash(n * rate)
    }
  },
  computed: {
    currentUserCurrency(){
      return this.$store.getters["auth/currency"];
    },
    currentUserRate(){
      let rate = this.currentUserCurrency === "EUR" ? 1 : this.$store.getters["exchange/rates"][this.$store.getters["auth/currency"]];
      return rate ? rate : 1;
    },
    currencies(){
      return getCurrencies();
    },
    currentUserCurrencySymbol(){
      let currentCurrencyObj = _.find(this.currencies,(c) => c.code === this.currentUserCurrency)
      return currentCurrencyObj.symbol;
    }
  },
  mounted() {
    this.loadViewData();
  },
  methods: {
    loadViewData() {
      this.loadTeam();
    },
    async loadTeam() {
      this.loading = true;
      let teamResponse = await TeamService.getTeamInfo(this.teamId);
      this.team = teamResponse.data;
      this.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/TeamWidget.vue